// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.div_PtnP8 {
    width: 100%;
}

.flex_zMtuF {
    flex-grow: 1;
}

.selector_tY1XZ {
    overflow-x: auto;
    margin-bottom: 24px;
    max-height: 50vh !important;
}

.item_uHJkF {
    padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/kmxZone/CarMaxZoneSearch.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".div {\n    width: 100%;\n}\n\n.flex {\n    flex-grow: 1;\n}\n\n.selector {\n    overflow-x: auto;\n    margin-bottom: 24px;\n    max-height: 50vh !important;\n}\n\n.item {\n    padding-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"div": `div_PtnP8`,
	"flex": `flex_zMtuF`,
	"selector": `selector_tY1XZ`,
	"item": `item_uHJkF`
};
export default ___CSS_LOADER_EXPORT___;
